import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './index';

/**
 * 使用类型化的 dispatch hook
 * @returns {AppDispatch} 类型化的 dispatch 函数
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();

/**
 * 使用类型化的 selector hook
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
